import React from 'react'
import { Mask } from 'react-weui'
import { browserHistory } from 'react-router'
import shuangqian2Img from '../../images/medals/shuangqian2.png'
import closeImg from '../../images/close-grey.png'
import { WKVisible } from '../../components/wk'
import showCertificateBtnImg from '../../images/medals/show-certificate-btn.png'

class WKMedalModal extends React.Component {
    onClickClose () {
        if (this.props.onClickClose) {
            this.props.onClickClose()
        }
    }
    onClickCertificate (type, id) {
        if (this.props.onClickCertificate) {
            this.props.onClickCertificate()
        }
        location.assign(`/specials/activity/certificate?type=${type}&id=${id}`)
    }
    render() {
        return (
            <WKVisible show={this.props.show}>
                <div className="wk-medal-modal">
                    <Mask onClick={e => this.onClickClose()} />
                    <div className="content">
                        <div className="close" onClick={e => this.onClickClose()}>
                            <img src={closeImg} className='wk-pointer-hand' />
                        </div>
                        <WKVisible show={this.props.type === 'tt_achieve'}>
                            <div className="img">
                                <img src={shuangqian2Img} alt=""/>
                            </div>
                            <div className="title">
                                最具潜力店铺
                            </div>
                            <div className="desc">
                                荔课签约店铺，战略合作伙伴
                            </div>
                            <WKVisible create={this.props.isShowBtn}>
                                <button 
                                    className='show-certificate-btn' 
                                    onClick={e => this.onClickCertificate(this.props.type, this.props.liveroomId)}
                                >
                                    <img src={showCertificateBtnImg} />
                                </button>
                            </WKVisible>
                        </WKVisible>
                    </div>
                </div>
            </WKVisible>
        )
    }
}

export default WKMedalModal



// WEBPACK FOOTER //
// ./src/components/medal/MedalModal.js